import axios from "axios";
import { getAuthBasePath } from "../Auth/basepath-service";
import { getSessionId } from "../Session/session-service";

/** Ambiente atual da aplicação */
const env = import.meta.env.VITE_ENV;

/** URLs da API configuradas por ambiente */
const urls = {
  dev: import.meta.env.VITE_API_BASE_URL_DEV,
  hmg: import.meta.env.VITE_API_BASE_URL_HMG,
  prod: import.meta.env.VITE_API_BASE_URL_PROD,
};

/** URL base da API selecionada baseada no ambiente */
const API_BASE_URL = urls[env] || urls.dev;

/**
 * Instância do Axios configurada para a aplicação
 * Inclui URL base, headers padrão e interceptors para autenticação
 */
export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "client-id": "bZqvTnLmRp4xYcKsHjQwVePuIoAzXy",
  },
});

/**
 * Interceptor de requisição para gerenciamento automático de autenticação
 * Adiciona sessionId automaticamente e reescreve URLs baseado no fluxo de autenticação
 * 
 * Funcionalidades:
 * - Adiciona header x-session-id quando disponível
 * - Exclui sessionId da requisição de inicialização (/device-auth/init)
 * - Reescreve URLs de /auth para /device-auth quando no fluxo de device-auth
 */
api.interceptors.request.use(
  (config) => {
    const sessionId = getSessionId();
    
    // Não exigir sessionId para a requisição de inicialização
    if (config.url === '/device-auth/init') {
      // Requisição de inicialização, sessionId não obrigatório
    } else if (sessionId) {
      config.headers['x-session-id'] = sessionId;
    }

    // Reescrever a URL quando estivermos no fluxo de device-auth
    const basePath = getAuthBasePath();
    if (config.url && basePath === '/device-auth') {
      // Se a rota começa com /auth, troca para /device-auth
      if (config.url.startsWith('/auth/')) {
        config.url = config.url.replace('/auth/', '/device-auth/');
      }
      // Se for exatamente /auth, troca para /device-auth
      if (config.url === '/auth') {
        config.url = '/device-auth';
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
